import { request } from '@/utils/request';
import { generateSearchParams } from '@/utils/generateSearchParams';
import { ResponseBasis } from '@/api/api.types';
import { DoctorFullResponse, DoctorItem, DoctorsListOptions } from '@/api/doctors/doctors.types';

export async function getDoctorsList(options: DoctorsListOptions) {
  const searchParams = generateSearchParams(options);
  return request<ResponseBasis<DoctorItem>>(`/doctor/?${searchParams.toString()}`);
}

export async function getCurrentDoctor({ id }: { id: number }) {
  return request<DoctorFullResponse>(`/doctor/${id}/`);
}